<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">Staff Information</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <div class="container mt-4">
                    <div class="row g-4 justify-content-center">
                        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let item of paginated_teachers_info">
                            <!-- Ultimate 3D Profile Card -->
                            <div class="ultimate-3d-profile-card d-flex flex-column">
                                <div class="profile-image-container">
                                    <img [src]="item.ImageLink || 'assets/img/default-teacher.png'" alt="staff" />
                                </div>
                                <div class="profile-content flex-grow-1 d-flex flex-column">
                                    <h3 class="profile-name">{{ item.EmployeeName }}</h3>
                                    <p class="profile-role">{{item.Designation }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- No Data Found Message -->
                    <div *ngIf="paginated_teachers_info.length === 0">
                        <div class="text-center py-5">
                            <div class="ultimate-3d-card p-5 mx-auto" style="max-width: 400px;">
                                <i class="fa-solid fa-users-slash" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                                <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Data Found</h3>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center mt-5 mb-5" *ngIf="totalPages.length > 1">
                        <button class="premium-glass-btn mx-1" (click)="onPageChange(pageIndex - 1)" [disabled]="pageIndex === 0">Previous</button>
                        <button class="premium-glass-btn mx-1" *ngFor="let page of totalPages; let i = index" (click)="onPageChange(i)" [ngStyle]="{'background': pageIndex === i ? 'linear-gradient(135deg, #0d8b54, #0f4c3a)' : '', 'color': pageIndex === i ? '#ffffff' : ''}">{{ page }}</button>
                        <button class="premium-glass-btn mx-1" (click)="onPageChange(pageIndex + 1)" [disabled]="pageIndex + 1 >= totalPages.length">Next</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
